import * as apiHelper from '../../../apiHelper';

import { setUserData } from '../../global/actions'
const controller = 'notifications';
const mcontroller = 'messages';

export function updateNotification(notification) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPut(controller, notification, state.Global.token, notification._id);
  }
}

export function dismissNotification(notification) {
  return (dispatch, getState) => {
    const oldDismissed = notification.dismissed;
    notification.dismissed = true;

    const state = getState();

    let user = Object.assign({}, state.Dashboard.user);
    user.notifications.map((n, i) => {
      if (n._id === notification._id) {
        user.notifications[i].dismissed = true;
      }
    })

    user.notifications = user.notifications.slice(0);
    dispatch(setUserData(user));

    if (oldDismissed !== notification.dismissed)
      dispatch(updateNotification(notification));
  }
}

export function getMessagingToken() {
  return (dispatch, getState) => {
    let state = getState();
    let body = { device: 'browser' };
    return apiHelper.apiPost(mcontroller, body, state.Global.token, notification._id);
  }
}

export function createMessagingChannel(userId, message) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost(mcontroller, { userId: userId }, state.Global.token, 'channels')
      .then(response => response.json())
      .then(json => {
        if (json.error || !message) { return; }
        // Channel Created; Send message if there is one
        //let messagingClient = state.Dashboard.messagingClient;
        //sendMessage(messagingClient, json.channel.sid, message);
      })
  }
}

export function sendMessageNotification(userId) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPost(mcontroller, { userId: userId }, state.Global.token)
      .then(response => response.json())
      .then(json => {
        if (json.error || !message) { return; }
        // Channel Created; Send message if there is one
        //let messagingClient = state.Dashboard.messagingClient;
        //sendMessage(messagingClient, json.channel.sid, message);
      })
  }
}

function sendMessage(client, channelSid, message) {
  if (!client)
    return;

  //If client is not ready, wait until it is
  if (client.connectionState !== 'connected') {
    setTimeout(() => {
      sendMessage(client, channelSid, message)
    }, 400);
    return;
  }
  //Client is ready; lets roll.
  client.getChannelBySid(channelSid).then(_channel => {
    _channel.sendMessage(message).then(_message => {
      _channel.updateLastConsumedMessageIndex(_message.index).then(v => { });
    })
  })
}
